// extracted by mini-css-extract-plugin
export var currencyInput = "_oh-1";
export var currencySymbol = "_oh-0";